// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button__WxFtRaYK1t{padding-left:var(--dixa-size-spacer-100)}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/header/toolbar/components/transferToQueue/conversationTransferToQueue.module.scss"],"names":[],"mappings":"AAEA,oBACE,wCAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.button {\n  padding-left: var(--dixa-size-spacer-100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button__WxFtRaYK1t`
};
export default ___CSS_LOADER_EXPORT___;
